import { ReactComponent as LogoSVG } from '../../assets/Logo.svg';
import { Link } from 'react-router-dom';
import "./Logo.css"

function Logo() {
  return (
    <div className="logo-container">
      <Link to="/home">
        <LogoSVG className="logo-svg"/>
      </Link>
    </div>
  );
}

export default Logo;
